// extracted by mini-css-extract-plugin
export var bookingButton = "PrivateEngine-module--bookingButton--GXjq8";
export var bookingText = "PrivateEngine-module--bookingText--b9x4h";